import React from "react";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  User,
} from "@heroui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { logLogout } from "../../../utils/activityLogger";

const OperatorHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pageTitles = {
    "/admin/dashboard": "Dashboard",
    "/admin/metric": "Metric",
    "/admin/users": "Users",
    "/admin/markets": "Markets",
    "/admin/matches": "Matches",
    "/admin/operators": "Operators",
    "/admin/bets":"Bets",
    "/admin/betsHistory": "Bets History",
    "/admin/betsInsights": "Bet Insights",
    "/admin/changePassword": "Change Password",
    "/admin/results": "Results",
  };

  const flushItem = async () => {
    await logLogout();
    localStorage.clear();
    navigate("/login");
  };

  const currentTitle = pageTitles[location.pathname] || "Dashboard";
  return (
    <>
      <div className="flex flex-row justify-between items-center flex-wrap gap-y-2 px-8 bg-white py-2 mt-1">
        {/* Left side (logo / breadcrumb) */}
        <div className="capitalize">
          <nav aria-label="breadcrumb" className="w-max">
            <ol className="flex flex-wrap items-center w-full bg-opacity-60 rounded-md bg-transparent p-0 transition-all">
              <li className="flex items-center text-blue-gray-900 antialiased font-sans text-sm font-normal leading-normal cursor-pointer transition-colors duration-300 hover:text-light-blue-500">
                <a href="/operator/dashboard">
                  <p className="block antialiased font-sans text-sm leading-normal text-blue-gray-900 font-normal opacity-50 transition-all hover:text-blue-500 hover:opacity-100">
                    Matka
                  </p>
                </a>
                <span className="text-blue-gray-500 text-sm antialiased font-sans font-normal leading-normal mx-2 pointer-events-none select-none">
                  /
                </span>
              </li>
              <li className="flex items-center text-blue-gray-900 antialiased font-sans text-sm font-normal leading-normal cursor-pointer transition-colors duration-300 hover:text-light-blue-500">
                <p className="block antialiased font-sans text-sm leading-normal text-blue-gray-900 font-normal">
                  {currentTitle}
                </p>
              </li>
            </ol>
          </nav>
        </div>

        {/* Right side (Admin dropdown) */}
        {/* <div className=" items-center gap-4 hidden md:flex ">
    <Dropdown placement="bottom-start">
      <DropdownTrigger>
        <User
          as="button"
          avatarProps={{
            isBordered: true,
            src: "https://i.pravatar.cc/150?u=a042581f4e29026024d",
          }}
          className="transition-transform"
          description={localStorage.getItem("email") || ""}
          name={localStorage.getItem("name") || ""}
        />
      </DropdownTrigger>
      <DropdownMenu aria-label="User Actions" variant="flat">
        <DropdownItem
          key="logout"
          color="danger"
          className="bg-admin_black text-white text-center"
          onClick={() => flushItem()}
        >
          Log Out
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</div> */}

        <div className="items-center gap-4 hidden md:flex">
          <Dropdown placement="bottom-start">
            <DropdownTrigger>
              <User
                as="button"
                avatarProps={{
                  isBordered: true,
                  src: "https://i.pravatar.cc/150?u=a042581f4e29026024d",
                }}
                className="transition-transform"
                description={localStorage.getItem("username") || ""}
                name={localStorage.getItem("name") || ""}
              />
            </DropdownTrigger>
            <DropdownMenu aria-label="User Actions" variant="flat">
              {/* <DropdownItem key="profile" className="h-14 gap-2">
                <p className="font-bold">Signed in as </p>
                <p className="font-bold">Admin</p>
              </DropdownItem> */}
              <DropdownItem
                key="logout"
                color="danger"
                className="bg-admin_black text-white text-center"
                onClick={() => flushItem()}
              >
                Log Out
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};
export default OperatorHeader;
